/**
 * Keys for the custom attributes on Redo cart lines: the contract between the
 * product page that builds a line and the checkout that consumes it.
 */

/** Safety stock buffer for an inventory-config setup line. */
export const SAFETY_STOCK_ATTRIBUTE = "safetyStock";

/** Inventory the merchant reports having when setting the config up. */
export const ON_HAND_INVENTORY_ATTRIBUTE = "onHandInventory";

/** Cases to reorder, when it differs from the line's own quantity. */
export const REORDER_QUANTITY_ATTRIBUTE = "reorderQuantity";

/** SuppliesTrackableProductType the line configures. */
export const TRACKABLE_TYPE_ATTRIBUTE = "trackableType";

/** JSON array of parcel oids a parcel-packaging config is tied to. */
export const TIED_PARCEL_OIDS_ATTRIBUTE = "tiedParcelOids";

/** Cadence unit for a time-based subscription line. */
export const ORDER_INTERVAL_ATTRIBUTE = "orderInterval";

/** How many intervals between subscription orders. */
export const ORDER_INTERVAL_FREQUENCY_ATTRIBUTE = "orderIntervalFrequency";

/** Marks a line as claimed under a free-item promotion. */
export const SUPPLIES_PROMOTION_ATTRIBUTE = "suppliesPromotionId";

/** Whether a line is an inventory-config setup line. */
export function hasSafetyStockAttribute(
  attributes: readonly { key: string }[],
): boolean {
  return attributes.some(
    (attribute) => attribute.key === SAFETY_STOCK_ATTRIBUTE,
  );
}

/** The safety stock attribute, if the line carries one. */
export function findSafetyStockAttribute<T extends { key: string }>(
  attributes: readonly T[],
): T | undefined {
  return attributes.find(
    (attribute) => attribute.key === SAFETY_STOCK_ATTRIBUTE,
  );
}
